import Model from 'src/app/core/models/model';

export default class ScreenModel extends Model {
  name: string;
  status?: Status;

  constructor() {
    super();
  }
}

export type Status = 'Active' | 'Inactive';
